import React from "react";
import { Card, Page, SkeletonBodyText, VerticalStack } from "@shopify/polaris";

import useFormatMessage from "../../hooks/useFormatMessage";
import useSettingsPage from "../../hooks/useSettingsPage";
import AddButton from "../AddButton/AddButton";
import FilterContainer from "../FilterContainer/FilterContainer";
import ReviewChecklistPageHeader from "../ReviewChecklistPageHeader/ReviewChecklistPageHeader";
import SearchTextField from "../SearchTextField/SearchTextField";

const ReviewChecklistPageSkeleton = () => {
  const f = useFormatMessage();

  useSettingsPage();

  return (
    <Page
      title={f("review.checklists.page.title")}
      primaryAction={<AddButton disabled>{f("review.checklists.page.add.button.label")}</AddButton>}
    >
      <VerticalStack gap="8">
        <ReviewChecklistPageHeader />
        <FilterContainer>
          <SearchTextField placeholder={f("review.checklists.page.filter.placeholder")} labelHidden disabled />
        </FilterContainer>

        <Card>
          <Card.Section>
            <SkeletonBodyText />
          </Card.Section>
        </Card>
      </VerticalStack>
    </Page>
  );
};

export default ReviewChecklistPageSkeleton;
